var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.file)?_c('vue-pdf-embed',{attrs:{"source":_vm.file,"disable-text-layer":true},on:{"rendered":_vm.handleRendered,"loading-failed":_vm.handleError,"rendering-failed":_vm.handleError}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }